<template>
	<div class="container__pagination flex w-full content-between">
		<span class="flex items-center"
			>{{ $t('exibindo') }} {{ quantityPerPage * atualPage - (quantityPerPage - 1) }} -
			{{ quantityPerPage * atualPage > totalRecords ? totalRecords : quantityPerPage * atualPage }}
			registros</span
		>
		<div class="container__pagination__pageinfo gap-1">
			<div class="flex">
				<label>{{ $t('exibir') }}</label>
				<select
					class="container__pagination__pageinfo__select"
					:value="quantityPerPage"
					@change="onSelectChange($event)"
				>
					<option
						v-for="(quantity, key) in quantityPerPageOptions"
						:key="key"
						:value="quantity"
					>
						{{ quantity }}
					</option>
				</select>
				<label> de {{ totalRecords }} registros</label>
			</div>
			<div class="container__pagination__pages">
				<i
					:class="[
						'fas fa-arrow-left container__pagination__elements__arrow',
						{
							'container__pagination__elements__arrow--disablled ': atualPage == 1,
						},
					]"
					@click="onPreviousPage"
				/>
				<label>{{ atualPage }}</label>
				<i
					:class="[
						'fas fa-arrow-right container__pagination__elements__arrow',
						{
							'container__pagination__elements__arrow--disablled ': atualPage == maxPages,
						},
					]"
					@click="onNextPage"
				/>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		/**
		 * Quantidade de registros por pagina
		 */
		quantityPerPage: Number,
		/**
		 * Opcoes que estarao disponiveis de quantos registros podem ser exibidos por pagina
		 */
		quantityPerPageOptions: Array,
		/**
		 * Numero total de registros
		 */
		totalRecords: Number,
	},
	data: () => {
		return {
			atualPage: 1,
			startIndex: 0,
		}
	},
	computed: {
		maxPages: function () {
			return Math.ceil(this.totalRecords / this.quantityPerPage)
		},
	},
	created() {
		this.$emit('setStartEnd', this.startIndex)
	},
	methods: {
		/**
		 * Quando muda o numero de registros que devem ser exibidos por pagina
		 */
		onSelectChange(e) {
			let quantityPerPage = parseInt(e.target.value)
			this.$emit('setQuantityPerPage', quantityPerPage)
			this.resetToFirstPage()
		},
		/**
		 * Mudar para pagina anterior
		 */
		onPreviousPage() {
			if (this.atualPage !== 1) {
				this.atualPage--
				this.startIndex -= this.quantityPerPage
				this.$emit('setStartEnd', this.startIndex)
			}
		},
		/**
		 * Mudar para proxima pagina
		 */
		onNextPage() {
			if (this.atualPage !== this.maxPages) {
				this.atualPage++
				this.startIndex = this.startIndex + this.quantityPerPage
				this.$emit('setStartEnd', this.startIndex)
			}
		},
		/**
		 * Reseta para a primeira pagina
		 */
		resetToFirstPage() {
			this.atualPage = 1
			this.startIndex = 0
			this.$emit('setStartEnd', this.startIndex)
		},
	},
}
</script>

<style scoped>
.container__pagination {
	font-size: 0.75rem;
	display: flex;
	width: 100%;
	justify-content: space-between;
}

.container__pagination label {
	user-select: none;
}

.container__pagination__pageinfo,
.container__pagination__pages {
	display: flex;
	align-items: center;
}

.container__pagination__pageinfo__select {
	font-size: 0.75rem;
	height: 1rem;
	background-color: #ebecf0;
	border: none;
	margin: 0 0.2rem;
	padding: 0 0.2rem;
	user-select: none;
}

.container__pagination___pages {
	margin: 0 0.5rem;
}

.container__pagination__pages label {
	margin: 0.2rem;
}

.container__pagination__elements__arrow {
	font-size: 0.8rem;
	color: #636466;
	margin: 0 0.2rem;
	transition: transform 0.1s ease-in-out;
}

.container__pagination__elements__arrow:hover {
	color: rgb(var(--color-default));
	transform: scale(1.5);
}

.container__pagination__elements__arrow--disablled {
	color: #d7dadf;
}

.container__pagination__elements__arrow--disablled:hover {
	color: #d7dadf;
	transform: scale(1);
	cursor: not-allowed;
}
</style>
